// removed by extract-text-webpack-plugin
module.exports = {"block-heading":"_3doRatV6ouCSCh-jrjs25I","newslist-block":"_2fj05BU3E7VkWwKbM9H00z","frontpage":"_2HQrhlzlYUz-E00b-lU5ev","horizontal":"x3jmFEeC9TkrHVHb7EzF7","zebra":"_1I0o8HEUpyjObNi6x3HcGe","yellow":"PirWC6ckJ1I_dX6kxzHKk","darkgray":"_2HSZn7FgWw4ynaL3YvI-GV","heading":"_1Mk07-3gRjIYdWdz-0LWYI","description":"KrQDdI3fkwxtpW3QgtgS8","articles":"_389Tg_i8YuQNiylW-De-hq","button":"jEZg18ooaeh83zZEnSIIa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewsListBlock/NewsListBlock.module.scss
// module id = 792
// module chunks = 0